<template>
  <v-text-field
    v-model="dateComputed"
    v-mask="'##.##.####'"
    v-bind="$attrs"
    :label="label"
    :hint="hint"
    v-on="$listeners"
  />
</template>

<script>
import { TheMask } from "vue-the-mask"

export default {
  name: "TextDateField",
  components: { TheMask },
  model: {
    prop: "dateModel",
    event: "getDate"
  },
  props: {
    dateModel: { default: '' },
    label: { default: '' },
    hint: { default: '' },
    // readonly: { default: false }
  },
  data: () => ({
    dateComputed: '',
  }),
  watch: {
    dateComputed () {
      this.$emit("getDate", this.dateComputed)
      this.$emit("change", this.dateComputed)
    },
    dateModel () {
      this.dateComputed = this.dateModel
    }
  },
  mounted () {
    this.dateComputed = this.dateModel
  },
}
</script>

<style scoped>

</style>
